var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex justify-space-between align-center",
      class: _vm.summaryBackgroundColor
    },
    [
      _c("div", { staticClass: "d-flex align-center" }, [
        _c(
          "h4",
          { class: _vm.textClass },
          [
            _vm._t("label", [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.appendLabel + " " + _vm.label + " " + _vm.prependLabel
                  ) +
                  "\n            "
              )
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex align-center justify-end",
          staticStyle: { width: "150px" }
        },
        [
          _c(
            "h4",
            { staticClass: "mr-1", class: _vm.textClass },
            [
              _vm._t("value", [
                _vm._v(
                  "\n                " + _vm._s(_vm.value) + "\n            "
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("description", [
            _vm.description
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        color: _vm.infoIconColor,
                                        small: ""
                                      }
                                    },
                                    "v-icon",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n                        $mdiInformation\n                    "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1151502461
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.description) }
                    })
                  ]
                )
              : _vm._e()
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }